GP.views.ThreadLayout = Backbone.Marionette.LayoutView.extend({
    initialize: function() {
        // this.id format: thread-8B006A05626FFB04
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':setup_observer', this.setup_observer);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':messages_loaded', this.messages_loaded);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':dom_refresh', this.dom_refresh);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_loading_spinner', this.show_loading_spinner);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_loading_spinner', this.hide_loading_spinner);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':add_rude_user_msg', this.add_rude_user_msg);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_quick_reply', this.show_quick_reply);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_rude_warning', this.show_rude_warning);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_priority_msg', this.show_priority_msg);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_priority_msg', this.hide_priority_msg);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_msg_approach_pref', this.show_msg_approach_pref);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':handle_show_msg_interests_overlay', this.handle_show_msg_interests_overlay);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_msg_approach_pref', this.hide_msg_approach_pref);

        // hide all priority message helpers/msgs on incoming message
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_priority_helpers', this.hide_priority_helpers);

        // show/hide the priority helper to promote a message to priority that has already been sent (after the fact)
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_sent_msg_priority', this.show_sent_msg_priority);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_sent_msg_priority', this.hide_sent_msg_priority);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':add_priority_tag', this.add_priority_tag);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':set_priority_input', this.set_priority_input);

        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_notification', this.show_notification);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':scroll_bottom', this.scroll_bottom);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':scroll_to_msg', this.scroll_to_msg);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':scroll_down', this.scroll_down);

        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_read_status_option', this.show_read_status_option, this);

        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_bronze_claimable', this.show_bronze_claimable, this);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_bronze_claimed', this.show_bronze_claimed, this);

        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':zoom_attachment', this.zoom_attachment);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':accept_attachment', this.accept_attachment);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_desktop_load_previous', this.hide_desktop_load_previous, this);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_desktop_load_previous', this.show_desktop_load_previous, this);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_desktop_load_more', this.show_desktop_load_more, this);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_mobile_load_previous', this.hide_mobile_load_previous);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_mobile_load_next', this.hide_mobile_load_next);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_mobile_load_next', this.show_mobile_load_next);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':set_selected', this.set_selected);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':toggle_priority', this.toggle_priority);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':handle_private_request', this.handle_private_request);

        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_ai_chatbot_notice', this.show_ai_chatbot_notice);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':assistant_intro_shown', this.handle_assistant_intro_shown);

        // mini-profile events
        this.listenTo(GP.vent, 'ThreadLayout:close', this.close);
        this.listenTo(GP.vent, 'ThreadLayout:minimize', this.minimize);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':close', this.close);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':maximize', this.maximize);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':minimize', this.minimize);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':add_friend', this.add_friend);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':add_favorite', this.add_favorite);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':grant_private', this.grant_private);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':remove_friend', this.remove_friend);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':remove_favorite', this.remove_favorite);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':revoke_private', this.revoke_private);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':block', this.block, this);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':vc_request_private', this.vc_request_private);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_private_popover', this.hide_private_popover);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':message_attach_modal', this.message_attach_modal);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_message_attach_popover', this.hide_message_attach_popover);

        // cometd typing events
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':show_typing_status', this.show_typing_status, this);
        this.listenTo(GP.vent, 'ThreadLayout.'+this.id+':hide_typing_status', this.hide_typing_status, this);

        // global events (removed in onBeforeDestroy)
        $(window).on('resize.'+this.options.thread.id+'_resize', _.debounce(this.window_resize.bind(this), 300));

        // reset this: if get_suggestion request was aborted or something else happened
        this.uiState.suggest_request_lock = false;
    },
    setup_observer: function() {
        let self = this;

        let options = {
            // root: this.$el.get(0),
            root: null,
            rootMargin: "0px",
            threshold: 0.1,
            // threshold: self.build_threshold_list(),
        };

        if (self.observer) {
            // console.warn('TL.setup_observer() disconnecting existing observer');
            self.observer.disconnect();
        }

        self.observer = new IntersectionObserver(_.debounce((entries) => {
            self.observer_handler(entries);
        }, 1000), options);

        setTimeout(() => {
            const dt_load_newer = self.$el.find('.msg-load-next-desktop-wrap button').get(0);
            if (dt_load_newer) {
                self.observer.observe(dt_load_newer);
            }

            const mobile_load_newer = self.$el.find('.mobile.message-load-previous button').get(0);
            if (mobile_load_newer) {
                self.observer.observe(mobile_load_newer);
            }

            const mobile_load_older = self.$el.find('.mobile.message-load-next button').get(0);
            if (mobile_load_older) {
                self.observer.observe(mobile_load_older);
            }

        }, 500);
    },
    observer_handler: function(entries) {
        // console.log('observer_handler() entries: ', entries);
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // console.log("Element is visible, triggering click on entry: ", entry);
                entry.target.click();
            }
        });
    },
    build_threshold_list: function() {
        let thresholds = [];
        let numSteps   = 20;

        for (let i = 1.0; i <= numSteps; i++) {
            let ratio = i / numSteps;
            thresholds.push(ratio);
        }

        thresholds.push(0);
        return thresholds;
    },
    template: function(serialized_data) {
        return template('thread-layout-tw', serialized_data);
    },
    className: 'message-thread docked',
    regions: {
        mini_profile: '.mini-profile-region',
        thread: '.thread-region'
    },
    ui: {
        mobile_load_previous: '.message-load-previous',
        mobile_load_next: '.message-load-next',
        thread_wrap: '.thread-wrap',
        nanoscroller: '.thread-wrap .nanoscroller',
        loading_wrap: '.thread-wrap .loading',
        loading_spinner: '.thread-wrap .loading .spinner-container',
        add_message_wrap: '.add-message-tw-wrap',
        message_input: '.message-input',
        message_input_id: '#chat-message-input',
        priority_input: '.priority-input',
        priority_icon: '.icon-priority',
        priority_icon_empty: '.icon-priority-empty',
        priority_msg: '.priority-helper.new-thread, .priority-helper.has-replies, .priority-helper.no-replies',
        priority_helper: '.priority-helper.active',
        message_send_button: '.message-send-button',
        notification_wrap: '.message-notification-wrap',
        notification_template: '.message-notification-wrap .notification-template',
        attachment_viewer_wrap: '.attachment-viewer-wrap',
        attachment_viewer_close: '.attachment-viewer-wrap .close',
        attachment_viewer_pic: '.attachment-viewer-wrap img',
        quick_reply_wrap: '.quick-reply-wrap',
        rude_warning_wrap: '.rude-warning-wrap',
        toggle_msg_approach_pref: '.msg-approach-pref-toggle',
        msg_interests_auto_show: '.msg-interests-auto-show',
        suggest_button: '.message-suggest-button',
        selected_personality: '#selected-personality',
        suggest_personality: '.message-suggest-personality',
        suggest_popover: '.message-suggest-popover',
        attach_button: '.message-attach-button',
        attach_input: '.message-attach-input',
        toggle_priority: '.priority-toggle',
        upgrade_overlay: '.upgrade-wrap',
        typing_status: '.message-typing-status',
        input_helper: '.message-input-helper',
        btn_msg_read_status: '.btn-msg-read-status',
        btn_msg_load_more: '.btn-msg-load-more',
        btn_msg_load_previous: '.btn-msg-load-previous',
        vc_request_private_popover: '.vc-request-private',
        btn_msg_hint_pref : '.btn-msg-hint-pref',
        menu_delete_thread : '.menu-delete-thread',
    },
    uiState: {
        suggest_intro_shown: false,
        suggest_request_lock: false,
    },
    events: {
        'click' : 'container_click',
        'click @ui.mobile_load_previous' : 'load_more',
        'click @ui.mobile_load_next' : 'load_next',
        'keydown @ui.message_input' : 'input_keydown',
        'click @ui.message_send_button' : 'add_message',
        'click @ui.attachment_viewer_close' : 'hide_zoom_attachment',
        'click @ui.toggle_msg_approach_pref' : 'toggle_msg_approach_pref',
        'click @ui.msg_interests_auto_show' : 'handle_msg_interests_auto_show',
        'click @ui.toggle_priority' : 'toggle_priority',
        'click @ui.suggest_personality' : 'show_message_suggest_popover',
        'click @ui.priority_msg' : 'toggle_priority',
        'click .quick-reply-wrap .maybe-later' : 'add_quick_reply',
        'click .quick-reply-wrap .delete-thread' : 'delete_thread',
        'click @ui.menu_delete_thread' : 'delete_thread',
        'blur @ui.message_input' : 'input_blur',
        'click @ui.btn_msg_read_status' : 'show_read_status_modal',
        'click @ui.btn_msg_load_more' : 'load_next',
        'click @ui.btn_msg_load_previous' : 'load_more',
        'click .vc-request-private' : 'vc_request_private_popover',
        'click .btn-message-attach-premium' : 'hide_message_attach_popover',
        'click @ui.btn_msg_hint_pref' : 'trigger_msg_hint_modal',
    },
    templateHelpers: {
        show_private_vc: function() {
            if (this.options.user.id != 69 && this.options.user.id != 80918084) {
                // $('#' + this.options.id).addClass('hide-private-vc');
                return (window._vc_beta) ? true : false;
            }
            return false;
        },
        show_ai_notice: function() {
            return _ai_chatbot_duids.includes(parseInt(this.options.user.id, 10));
        },
        show_priority_icon: function() {
            return !_ai_chatbot_duids.includes(parseInt(this.options.user.id, 10));
        },
        show_interests: function() {
            return this.options.user.get('interests') ? true : false;
        },
        is_ai_chatbot: function() {
            return _ai_chatbot_duids.includes(parseInt(this.options.user.id,10));
        },
        isnt_ai_chatbot: function() {
            return !_ai_chatbot_duids.includes(parseInt(this.options.user.id,10));
        },
        is_free_mobile_isnt_ai_chatbot: function() {
            return (GP.sdata.my_user.membership == 'FREE' && MoshPit.get_size() == 'mobile') &&
                !_ai_chatbot_duids.includes(parseInt(this.options.user.id,10));
        },
        is_not_ab_show_less: function() {
            return (GP.sdata.my_user.ab_variation != 'b' || GP.sdata.my_user.membership != 'FREE');
        }
    },
    serializeData: function() {
        var thread = this.options.thread;

        var billing_url = thread.get('billing_url');
        if (!billing_url) {
            billing_url = _free_user_redirect + '&sduid=' + this.options.user.get('duid');
        }

        var msg_approach_pref_key = this.options.user.get('msg_approach_pref');
        if (!(msg_approach_pref_key)) {
            msg_approach_pref_key = this.options.user.get('gender').toLowerCase() == 'man' ? 'SURPRISE' : 'POLITE';
        }

        var msg_interest_pref_hint = js_lang.msg_interest_pref_hint[this.options.user.get('gender').toLowerCase()];
        var interests = this.options.user.get('interests');

        // var msg_approach_pref_hint = js_lang.msg_approach_pref_hint[this.options.user.get('gender').toLowerCase()];
        var msg_approach_pref_hint = js_lang.msg_approach_pref_hint_short[this.options.user.get('gender').toLowerCase()];
        var msg_approach_pref = js_lang.msg_approach_pref[msg_approach_pref_key.toLowerCase()];

        return {
            other_username: this.options.user.get('username'),
            msg_approach_pref_hint: msg_approach_pref_hint,
            msg_approach_pref: msg_approach_pref,
            msg_approach_pref_link: '/members/modal/message_hint_pref',
            msg_interest_pref_hint: msg_interest_pref_hint,
            interests: interests,
            free_user_redirect: billing_url,
            options: this.options,
            ab_variation: GP.sdata.my_user.ab_variation
        };
    },
    onBeforeDestroy: function() {
        // if we don't minimize before closing the global handlers still need to be removed
        $(window).off('click.'+this.options.thread.id+'_outside_click');
        $(window).off('resize.'+this.options.thread.id+'_adjust');
        $(window).off('resize.'+this.options.thread.id+'_resize');
    },
    onRender: function() {
        var self = this;
        // console.trace('TL onRender... this: ', this);

        // the thread-layout has been shown, the thread itself is still being fetched/loading
        // we can still init anything we need to in the outer part of the thread
        if (MoshPit.get_size() == 'mobile') {
            if (!this.options.thread.metadata.first_page_reached) {
                this.ui.mobile_load_previous.show();
            }
            if (!this.options.thread.metadata.last_page_reached) {
                this.ui.mobile_load_next.show();
            }
        }

        // handle free/trial users
        var tags = this.options.thread.get('tag');
        var poke = (_.contains(tags, 'POKE')) ? true : false;

        if (this.options.user.id != 69 && this.options.user.id != 80918084 &&
            (GP.sdata.my_user.membership == 'FREE' && (poke || !this.options.thread.get('gold_initiated'))) ||
            (GP.sdata.my_user.membership != 'FREE' && this.options.thread.get('limit_reached'))) {
            this.show_upgrade_overlay();
        } else  {
            // handle paid users
            // if this is an unread thread, decrement_unread
            if (parseInt(this.options.thread.get('unread_total'), 10) > 0) {
                this.options.thread.set('unread_total', 0);
                GP.vent.trigger('MessagePane.Inbox:decrement_unread', this.options.thread.id);
            }
        }

        // handle fling_master
        if (this.options.user.id == 69) {
            this.$el.addClass('noreply hide-private-vc');
        }

        var assistant_settings = this.get_assistant_cookie();
        if (assistant_settings && assistant_settings.intro_shown) {
            this.ui.suggest_button.click(function(e) { self.suggest_message(e); });
        } else {
            this.ui.suggest_button.click(function() {
                var options = {
                    url: '/members/msg/get_suggestion_intro_modal/',
                    hidden: function() {
                        // NOTE: this should happen after the modal is hidden. its happening when its shown :/
                        GP.vent.trigger('ThreadLayout.' + self.id + ':assistant_intro_shown');
                    }
                };

                GP.vent.trigger('Modal:open', options);
            });
        }

        this.set_selected();

        // do this so we add the initial "mobile" class to threads that are started mobile
        if (MoshPit.get_size() == 'mobile') {
            this.window_resize();
        }

        if (GP.sdata.my_user.membership == 'FREE' && MoshPit.get_size() == 'mobile' && this.options.user.id != 69 && !_ai_chatbot_duids.includes(parseInt(this.options.user.id, 10))) {
            this.$el.find('.nanoscroller').addClass('nano');
        }
        if (GP.sdata.my_user.membership == 'FREE' && this.options.user.id != 69 && !_ai_chatbot_duids.includes(parseInt(this.options.user.id, 10))) {
            this.$el.addClass('message-free-user');
        }
        if (_ai_chatbot_duids.includes(parseInt(this.options.user.id, 10))) {
            this.$el.addClass('ai-chatbot-user');
        }
        if (this.duid != 69 && (this.options.user.get('pics').length <= 1)) {
            this.$el.addClass('thumbs-not-shown');
        }
        if (GP.sdata.my_user.membership == 'FREE' && this.$el.hasClass('docked')) {
            $('body').addClass('free-message-thread-docked');
        }
    },
    messages_loaded: function(open_to_msg_id) {
        // console.trace('TL.messages_loaded()');
        // console.warn('TL.messages_loaded() this.options: ', $.extend(true, {}, this.options));
        // console.warn('TL.messages_loaded() open_to_msg_id: ', open_to_msg_id);

        // the thread has been loaded and all the messages *should* be rendered (image attachments are still loading)
        if (MoshPit.get_size() != 'mobile') {
            this.init_nanoscroller(open_to_msg_id);
        } else {
            this.mobile_set_thread_height();
            if (!this?.options?.thread?.metadata?.bookmark) {
                // only scroll to the bottom the first time (before we have a bookmark)
                this.scroll_bottom();
            }
        }

        // initialize IntersectObserver for loading more messages
        this.setup_observer();

        // init add_message plugins. do this after msgs are rendered, we need to check the msgs to determine if file
        // upload is allowed
        if (this.ui.add_message_wrap.is(':visible')) {

            if (this.ui.attach_button.is(':visible')) {
                var self = this;

                // disable file_upload: men with no organic reply
                if (this.should_disable_file_upload()) {
                    this.ui.attach_button.click(function(e) {
                        e.preventDefault();
                        self.show_notification('warning', js_lang.no_attachment_explaination);
                    });
                } else {
                    // woman and approved premium: show premium file upload popover
                    if (GP.sdata.my_user.premium_status == 'APPROVED_INITIAL' ||
                        GP.sdata.my_user.premium_status == 'DENIED_FINAL' ||
                        GP.sdata.my_user.premium_status == 'PENDING_FINAL' ||
                        GP.sdata.my_user.premium_status == 'APPROVED_FINAL' ||
                        GP.sdata.my_user.gender === 'WOMAN') {
                        this.init_premium_file_upload_popover();
                    } else {
                        // everyone else: init the normal file upload
                        var $parentLabel = this.$el.find('.add-message-wrap .message-attach-button label');
                        this.init_file_upload($parentLabel);
                    }
                }
            }

            if (this.ui.message_input.is(':visible')) {
                // character count warning
                this.ui.message_input.simplyCountable({
                    container: '.message-char-count',
                    showNum: 800,
                    counter: '.message-char-count .count',
                    countType: 'characters',
                    maxCount: 1000,
                    strictMax: true,
                    countDirection: 'up',
                    thousandSeparator: ''
                });
            }
        }

    },
    dom_refresh: function() {
        if (MoshPit.get_size() == 'mobile') {
            if (this?.options?.thread?.metadata?.bookmark) {
                var scrollPosition = parseInt($('#'+this.options.thread.metadata.bookmark).position().top,0);
                this.ui.thread_wrap.scrollTop(scrollPosition);
            }
        } else {
            // only do this if nanoscroller has already been init'd
            if (this.ui.nanoscroller.hasClass('nano')) {
                // refresh nanoScroller because the size of the element its scrolling has changed
                // optionally scroll to where we were before more messages were added
                if (this.options.thread.metadata.bookmark.length) {
                    let $bookmark = $('#'+this.options.thread.metadata.bookmark).get(0);
                    if ($bookmark) {
                        // this.ui.nanoscroller.nanoScroller({ scrollTo: $('#'+this.options.thread.metadata.bookmark) });
                        this.ui.nanoscroller.nanoScroller({ scrollTo: $bookmark });
                    }
                } else {
                    //this.ui.nanoscroller.nanoScroller();
                }
            }
        }
    },
    is_selected: function() {
        return this.$el.hasClass('selected');
    },
    container_click: function(e) {
        if (
            this.options.user.id != 69 
            && GP.sdata.my_user.membership == 'FREE' 
            && GP.sdata.my_user.gender == 'MAN' && MoshPit.get_size() == 'mobile'
            && (e && !$(e.target).hasClass('sent-via') && !$(e.target).hasClass('btn-via-notice'))
            && !_ai_chatbot_duids.includes(parseInt(this.options.user.id,10))
        ) {
            GP.vent.trigger('Page:billing_redirect');
        }

        this.set_selected();
    },
    set_selected: function(e) {
        if (this.isDestroyed) {
            return;
        }

        if (e && ($(e.target).hasClass('minimize'))) {
            return;
        }

        var shown_classes = 'message-thread-shown';
        if (!this.$el.hasClass('docked')) {
            shown_classes += ' message-thread-maximized';
        }

        if (_ai_chatbot_duids.includes(parseInt(this.options.user.id,10))) {
            shown_classes += ' ai-chatbot-thread-shown';
        }
        if (parseInt(this.options.user.id,10) === 69) {
            shown_classes += ' site-master-thread-shown';
        }

        $('body').addClass(shown_classes);

        if (this.is_selected()) {
            return;
        }

        if (window._message_thread_autosize_timer) {
            clearTimeout(window._message_thread_autosize_timer);
        }

        $('#message-thread-wrap .message-thread').removeClass('selected');
        this.$el.addClass('selected');
        if (this.options.user.id != 69 && !GP.sdata.is_mobile &&
            GP.sdata.my_user.membership != 'FREE' && !this.options.thread.get('limit_reached')) {
            this.ui.message_input.focus();
        }
        GP.vent.trigger('Cometd:messenger_thread_subscribe', this.options.thread.id);
        GP.vent.trigger('Cometd:messenger_send_open_status', this.options.thread.id);
        GP.vent.trigger('MessagePane.Inbox:add_selected', this.options.thread.id);
        GP.vent.trigger('ThreadMiniProfile.'+this.options.thread.id+':hide_unread_count');

        if (GP.sdata.my_user.membership != 'FREE') {
            // textarea autosize
            if (this.ui.message_input) {
                autosize(this.ui.message_input);
            } else {
                autosize(this.$el.find('textarea.message-input'));
            }
        }
    },
    remove_selected: function() {
        if (this.is_selected()) {
            GP.vent.trigger('MessagePane.Inbox:remove_selected');
            this.$el.removeClass('selected');
        }
    },
    close: function(obj) {
        // console.trace('TL.close() obj: ', obj);
        // console.log('TL.close() this.options: ', $.extend(true, {}, this.options));
        // console.log('TL.close() this.options.thread.metadata: ', $.extend(true, {}, this.options.thread.metadata));

        var only_maximized = (obj && obj.only_maximized) ? obj.only_maximized : null;
        var leave_rdrawer_open = (obj && obj.leave_rdrawer_open) ? obj.leave_rdrawer_open: null;
        var opened_from = this.options.thread.metadata.opened_from;

        //maximized thread (full view)
        if (!this.$el.hasClass('docked')) {
            $('#message-thread-backdrop').hide();
        } else if (only_maximized) {
            return;
        }

        if (this.is_selected()) {
            GP.vent.trigger('MessagePane.Inbox:remove_selected');
        }

        var loaded_external = this.options.thread.get('loaded_external');
        if (MoshPit.get_size() == 'mobile' && !opened_from && !leave_rdrawer_open && loaded_external) {
            GP.vent.trigger('RightDrawer:hide');
        }

        var thread_id = this.options.thread.id;
        this.destroy();
        GP.vent.trigger('Cometd:messenger_thread_unsubscribe', thread_id);
        GP.vent.trigger('MessagePane.Thread:close_thread', thread_id);

        // remove class forcing maximized thread for site master
        $('body').removeClass('message-thread-force-maximized');

        if ($('#message-thread-wrap').children().length === 0) {
            $('body').removeClass('message-thread-shown message-thread-maximized site-master-thread-shown');
        }

        if (MoshPit.get_size() == 'mobile') {
            if (opened_from == 'activity') {
                vent.trigger('RightDrawer:show', 'ActivityPane');
            } else if (opened_from == 'friends') {
                vent.trigger('RightDrawer:show', 'FriendPane');
            }
        }
    },
    maximize: function(obj) {
        // console.trace('TL.maximize() obj: ', obj);
        var my_ts = GP.sdata.thread_style,
            force = (typeof obj != 'undefined' && obj.force === true) ? true : false;

        if (force && MoshPit.get_size() != 'mobile') {
            force = false;
        }
        if (my_ts != 2 && !force) {
            GP.vent.trigger('ThreadLayout:close', { only_maximized: true });
        }

        // add class to force maximized thread view on mobile for site master etc...
        if (force) {
            $('body').addClass('message-thread-force-maximized');
        }

        var minimize_input = {};
        if (this.$el.hasClass('minimized') || force) {
            this.$el.removeClass('minimized').find('.mini-profile-top').removeClass('minimized');
            if (force) {
                this.$el.removeClass('docked');
            }
            GP.vent.trigger('Cometd:messenger_thread_subscribe', this.options.thread.id);
        } else if (this.$el.hasClass('docked')) {
            this.$el.removeClass('docked');
            this.$el.css('right', '');
            if (this.ui.nanoscroller.hasClass('nano')) {
                this.ui.nanoscroller.nanoScroller();
                this.ui.nanoscroller.nanoScroller({ scroll: 'bottom' });
            }
            $('#message-thread-backdrop').show();
            this.$el.find('.sent-via span, .sent-via .qm').popover('hide');

            // bind global click/resize handlers for this thread
            // IMPORTANT! these must be manually removed with .off() either in minimize() or onBeforeDestroy()
            var self = this;
            $(window).on('click.'+this.options.thread.id+'_outside_click', function(e) { self.handle_outside_click(e); });
            $(window).on('resize.'+this.options.thread.id+'_adjust', _.debounce(this.adjust_overlay_size.bind(this), 250));
            this.adjust_overlay_size();
        }
        this.set_selected();
    },
    minimize: function(obj) {
        if (MoshPit.get_size() != 'mobile') {
            var exclude_thread_id = (obj && obj.exclude_thread_id) ? obj.exclude_thread_id : null;
            var single_thread_id = (obj && obj.single_thread_id) ? obj.single_thread_id : null;
            var full_minimize = (obj && obj.full_minimize) ? obj.full_minimize: null;
            var only_full = (obj && obj.only_full) ? obj.only_full: null;

            if (exclude_thread_id && this.options.thread.id == exclude_thread_id) {
                return;
            }
            if (single_thread_id && this.options.thread.id != single_thread_id) {
                return;
            }

            // full-view
            var was_full_view = false;
            if (!this.$el.hasClass('docked')) {
                was_full_view = true;
                $('#message-thread-backdrop').hide();
                $('body').removeClass('message-thread-maximized');
                this.$el.addClass('docked');
                this.ui.nanoscroller.nanoScroller();
                this.ui.nanoscroller.nanoScroller({ scroll: 'bottom' });
                GP.vent.trigger('MessagePane.Thread:position_threads');
                this.$el.find('.sent-via span, .sent-via .qm').popover('hide');

                // unbind global click/resize handlers for this thread
                $(window).off('click.'+this.options.thread.id+'_outside_click');
                $(window).off('resize.'+this.options.thread.id+'_adjust');
            }

            if (was_full_view) {
                // remove inline styles for maximized view that may be applied
                this.$el.css({ 'left' : '', 'width' : '' });
            }

            // docked-view, not minimized
            if (!only_full & (this.$el.hasClass('docked') && !this.$el.hasClass('minimized')) && (!was_full_view || full_minimize)) {
                this.remove_selected();
                GP.vent.trigger('Cometd:messenger_thread_unsubscribe', this.options.thread.id);
                this.$el.addClass('minimized').find('.mini-profile-top').addClass('minimized');
            }
        }
    },
    handle_outside_click: function(e) {
        if (MoshPit.get_size() != 'mobile') {
            // elements that are exempt from global click handler that minimizes/closes the maximized thread
            var outside_click_ignore = [
                '#message-pane', '.message-thread', '.close-thread', '#message-pane-tab',
                '.message-notification', '.inbox-thread-item', '#option-message',
                '.notification-body.new-message', '.rude-yes', '.rude-no',
                '.private-content-yes', '.private-content-no', '.modal', '.more-options-wrap'
            ];
            if (!$(e.target).closest(outside_click_ignore.join(',')).length) {
                // close thread if we have full-view set in our prefs
                if (GP.sdata.thread_style != 2) {
                    this.close();
                } else {
                    // minimize it if we are in docked mode
                    this.minimize({ single_thread_id : this.options.thread.id });
                }
            }
        }
    },
    window_resize: function() {
        // check if the view has been destroyed first
        // a race condition will run this code before the onBeforeDestroy() handler removes the event
        if (!this.isDestroyed) {
            var size = MoshPit.get_size();
            // moving to mobile view from non-mobile view
            if (size == 'mobile') {
                if (!this.$el.hasClass('mobile')) {
                    this.$el.removeAttr('style').addClass('mobile');
                    this.ui.thread_wrap.removeAttr('style');
                    this.destroy_nanoscroller();
                }
                // this needs to happen every time to account for the virtual keyboard
                this.mobile_set_thread_height();
                this.scroll_bottom();
            // moving from mobile view to non-mobile view
            } else if (size != 'mobile' && this.$el.hasClass('mobile')) {
                this.$el.removeClass('mobile');
                this.ui.thread_wrap.removeAttr('style');
                // since mobile only allows for one thread this wont get called multiple times (we're the only open thread)
                GP.vent.trigger('MessagePane.Thread:position_threads');
                setTimeout(this.init_nanoscroller(), 250);
            }
        }
    },
    adjust_overlay_size: function() {
        if (MoshPit.get_size() != 'mobile') {
            var rdrawer_width = 320;
            var overlay_default_width = 600;
            var left = this.$el.offset().left;
            var window_width = $(window).width();
            if (left < 0) {
                // clamp left side, unset fixed width
                this.$el.css({ 'left': 0, 'width' : 'auto' });
            }
            if (window_width > overlay_default_width + rdrawer_width) {
                // revert to default css
                this.$el.removeAttr('style');
            }
        }
    },
    mobile_set_thread_height: function() {
        // don't do this if add_message_wrap is hidden (site master threads)
        if (this.ui.add_message_wrap.css('display') == 'block') {
            // adjust the thread-wrap height (it needs this if we have only 1 or 2 messages)
            var additional_height = $(window).height() - (this.ui.add_message_wrap.offset().top + this.ui.add_message_wrap.outerHeight());
            this.ui.thread_wrap.css('min-height', (this.ui.thread_wrap.height() + additional_height));
        }
    },
    check_attach_button: function() {
        if (this.ui && this.ui.attach_button && (this.ui.attach_button instanceof jQuery)) {
            return true;
        }
        return false;
    },
    show_attach_spinner: function() {
        if (this.check_attach_button()) {
            this.ui.attach_button.find('svg').addClass('gp-hidden');
            this.ui.attach_button.find('.spinner-wrap').spin('gp_small').removeClass('gp-hidden');
        }
    },
    hide_attach_spinner: function() {
        if (this.check_attach_button()) {
            this.ui.attach_button.find('.spinner-wrap').spin(false).addClass('gp-hidden');
            this.ui.attach_button.find('svg').removeClass('gp-hidden');
        }
    },
    show_loading_spinner: function() {
        this.ui.loading_spinner.spin('gp_small');
        this.ui.loading_wrap.show();
    },
    hide_loading_spinner: function() {
        this.ui.loading_wrap.hide();
        this.ui.loading_spinner.spin(false);
    },
    show_suggest_spinner: function() {
        if (typeof(this.ui.suggest_button.attr) === 'function') {
            this.ui.suggest_button.attr('disabled', true);
            this.ui.suggest_button.find('svg').addClass('gp-hidden');
            this.ui.suggest_button.find('.suggest-spinner').removeClass('gp-hidden');
        }
    },
    hide_suggest_spinner: function() {
        if (typeof(this.ui.suggest_button.attr) === 'function') {
            this.ui.suggest_button.attr('disabled', false);
            this.ui.suggest_button.find('svg').removeClass('gp-hidden');
            this.ui.suggest_button.find('.suggest-spinner').addClass('gp-hidden');
        }
    },
    show_suggest_personality: function() {
        if (typeof(this.ui.suggest_personality) === 'object') {
            this.ui.suggest_personality.removeClass('gp-hidden');
        }
    },
    hide_suggest_personality: function() {
        if (typeof(this.ui.suggest_personality) === 'object') {
            this.ui.suggest_personality.addClass('gp-hidden');
        }
    },
    show_notification: function(type, text, html) {
        if (type != 'success' && type != 'info' && type != 'warning' && type != 'danger') {
            type = 'info';
        }

        if (typeof this.ui.notification_wrap.children != 'function') {
            return;
        }

        if (!text && !html) {
            return;
        }

        var notification;

        if (html) {
            notification = this.ui.notification_template.clone().removeClass('notification-template');
            notification.addClass('trial-upgrade').find('.notification-body').html(html);
            notification.removeClass('hide').addClass('alert-'+type).appendTo(this.ui.notification_wrap);

            return;
        }

        var notification_queue = this.ui.notification_wrap.children();
        if (notification_queue.length < 6) {
            // don't add the notification if its the same as the last one in the queue
            if (notification_queue.last().find('.notification-body').text() == text) {
                return;
            }
            notification = this.ui.notification_template.clone().removeClass('notification-template');
            notification.find('.notification-body').text(text);
            notification.removeClass('hide').addClass('alert-'+type).appendTo(this.ui.notification_wrap);
            var self = this;
            setTimeout(function() { self.hide_notification(notification); }, 5000);
        }
    },
    hide_notification: function(el) {
        el.remove();
    },
    add_rude_user_msg: function() {
        if (_ai_chatbot_duids.includes(parseInt(this.options.user.id,10))) {
            return;
        }

        var msg_model = {
            msg_id: 1,
            tag: [],
        };
        this.options.thread.get('messages').add(msg_model);
    },
    show_quick_reply: function() {
        if (this.ui.quick_reply_wrap.is(':hidden')) {
            // this.ui.thread_wrap.css('bottom', '+=27');
            this.ui.thread_wrap.find('.nano').nanoScroller();
            this.ui.quick_reply_wrap.show();
        }
    },
    show_rude_warning: function() {
        if (_ai_chatbot_duids.includes(parseInt(this.options.user.id,10))) {
            return;
        }

        var msg_model = {
            msg_id: 2,
            tag: [],
        };
        this.options.thread.get('messages').add(msg_model);
    },
    hide_rude_warning: function() {
        // remove msg_id 2
        this.options.thread.get('messages').remove(this.options.thread.get('messages').where({msg_id: 2}));
    },
    show_desktop_load_more: function() {
        var msg_model = {
            msg_id: 13,
            tag: [],
        };
        this.options.thread.get('messages').add(msg_model);
    },
    hide_desktop_load_more: function() {
        // remove msg_id 13
        this.options.thread.get('messages').remove(this.options.thread.get('messages').where({msg_id: 13}));
    },
    show_desktop_load_previous: function() {
        let msg_model = {
            msg_id: 14,
            tag: [],
        };
        this.options.thread.get('messages').add(msg_model);
    },
    hide_desktop_load_previous: function() {
        // remove msg_id 14
        this.options.thread.get('messages').remove(this.options.thread.get('messages').where({msg_id: 14}));
    },
    show_msg_approach_pref: function(timeout) {
        this.hide_msg_approach_pref();
        $('#' + this.id + ' .msg-approach-pref-helper').addClass('open').show();
        if (_msg_approach_pref_timer[this.id]) {
            clearTimeout(_msg_approach_pref_timer[this.id]);
        }
        _msg_approach_pref_timer[this.id] = setTimeout(this.hide_msg_approach_pref.bind(this), timeout);
    },
    handle_show_msg_interests_overlay: function(has_messages) {
        var cookie_chk = $.cookie('msg_interests_auto_show');
        if (!cookie_chk || cookie_chk === 'yes') {
            this.$el.find('.msg-interests-auto-show').prop('checked', true);

            if (has_messages) {
                this.$el.find('.interests-empty-thread-wrap').hide();
            } else {
                this.show_msg_approach_pref(120000);
            }
        } else {
            this.$el.find('.msg-interests-auto-show').prop('checked', false);
        }
    },
    hide_msg_approach_pref: function() {
        $('#' + this.id + ' .msg-approach-pref-helper').removeClass('open').hide();
    },
    show_priority_msg: function(priority_class, timeout) {
        this.hide_priority_msg();
        $('#' + this.id + ' .priority-helper.' + priority_class).show();
        if (_priority_msg_timer[this.id]) {
            clearTimeout(_priority_msg_timer[this.id]);
        }
        _priority_msg_timer[this.id] = setTimeout(this.hide_priority_msg.bind(this), timeout);
    },
    hide_priority_msg: function() {
        $('#' + this.id + ' .priority-helper').hide();
    },
    show_priority_helper: function() {
        this.hide_priority_msg();
        $('#' + this.id + ' .priority-helper.active').show();
    },
    hide_priority_helper: function() {
        $('#' + this.id + ' .priority-helper.active').hide();
    },
    show_input_helper: function() {
        if (!GP.sdata.is_mobile && !GP.sdata.is_tablet) {
            if (this.ui.typing_status.is(':hidden')) {
                $('#' + this.id + ' .message-input-helper').show();
            }
        }
    },
    hide_input_helper: function() {
        if (!GP.sdata.is_mobile && !GP.sdata.is_tablet) {
            $('#' + this.id + ' .message-input-helper').hide();
        }
    },
    show_sent_msg_priority: function() {
        if (_ai_chatbot_duids.includes(parseInt(this.options.user.id,10))) {
            return;
        }

        this.hide_priority_msg();
        this.hide_priority_helper();

        var msg_model = {
            msg_id: 3,
            tag: [],
        };
        this.options.thread.get('messages').add(msg_model);
    },
    hide_sent_msg_priority: function() {
        this.options.thread.get('messages').remove(this.options.thread.get('messages').where({msg_id: 3}));
    },
    show_ai_chatbot_notice: function() {
        var msg_model = {
            msg_id:12,
            tag: [],
        };
        this.options.thread.get('messages').add(msg_model);
    },
    hide_priority_helpers: function() {
        this.hide_priority_msg();
        this.hide_priority_helper();
        this.hide_sent_msg_priority();
    },
    add_priority_tag: function(msg_id, current_tags) {
        current_tags.push('PRIORITY');
        // removing the tag attribute from the model and then adding the tag back to trigger model changed event fires
        var msg_model = this.options.thread.get('messages').get(msg_id).set({tag: []}).set('tag', current_tags);
    },
    show_typing_status: function() {
        if (this.ui.input_helper.is(':visible')) {
            this.hide_input_helper();
        }
        this.ui.typing_status.show();
    },
    hide_typing_status: function() {
        this.ui.typing_status.hide();
    },
    show_upgrade_overlay: function(username) {
        if (GP.sdata.my_user.membership == 'FREE' && GP.sdata.my_user.gender == 'MAN') {
            this.ui.upgrade_overlay.find('.expire-msg').show();
        }
        this.$el.addClass('show-upgrade');
        this.ui.upgrade_overlay.removeClass('hide');
    },
    hide_upgrade_overlay: function() {
        this.ui.upgrade_overlay.addClass('hide');
    },
    hide_mobile_load_previous: function() {
        this.ui.mobile_load_previous.hide();
        this.hide_desktop_load_previous();
    },
    hide_mobile_load_next: function() {
        this.ui.mobile_load_next.hide();
        this.hide_desktop_load_more();
    },
    show_mobile_load_next: function() {
        if (MoshPit.get_size() == 'mobile') {
            this.ui.mobile_load_next.show();
        }
    },
    zoom_attachment: function(url) {
        GP.vent.trigger('Modal:open', {
            url: '/members/msg/zoom_attachment_modal/',
            attachment_url : url.replace('-M', '-L'),
            max_height: $( window ).height() * 0.70 //keep it from overflowing down
        });
    },
    hide_zoom_attachment: function() {
        // this.ui.thread_wrap.show();
        // this.ui.attachment_viewer_wrap.addClass('hide');
        // this.ui.attachment_viewer_pic.attr('src', '');
        // if (MoshPit.get_size() == 'mobile') {
        //     this.scroll_bottom();
        // }
    },
    accept_attachment: function() {
        var accept_data = { duid: this.options.user.id, type: 'APPROVED' };
        var thread_id = this.options.thread.id;
        $.post('/members/msg/add_message_attach_type', accept_data, function(post_data) {
            if (post_data.status) {
                GP.vent.trigger('MessagePane.Thread:reset_thread', thread_id);
            }
        });
    },
    add_quick_reply: function(e) {
        e.preventDefault();

        var msg_obj = {
            thread_id: this.options.thread.id,
            to_duid: this.options.user.id,
            message: js_lang.reply_maybe_later,
            tags_array: [],
        };
        GP.vent.trigger('MessagePane.Thread:add_message', msg_obj);
        this.options.thread.get('messages').replied = 1;
        this.close();
    },
    delete_thread: function(e) {
        e.preventDefault();

        var del_obj =  { 'name': 'thread-id', 'value' : this.options.thread.id };
        if (confirm(js_lang.confirm_delete_thread)) {
            // Inbox:del_threads() this calls ThreadLayout:close() for us
            GP.vent.trigger('MessagePane.Inbox:del_threads', [del_obj]);
        }
    },
    load_next: function(e) {
        this.load_more(e, 'ASC');
    },
    load_more: function(e, order = 'DESC') {
        // console.trace('TL.load_more() order: ', order);
        // console.warn('TL.load_more() this.options.thread.metadata: ', $.extend(true, {}, this.options.thread.metadata));
        // console.warn('TL.load_more() order: ', order);

        if (order == 'DESC' && this.options.thread.metadata.first_page_reached) {
            return;
        }

        if (order == 'ASC' && this.options.thread.metadata?.last_page_reached) {
            return;
        }

        // show spinner on desktop at top of thread when loading previous messages
        if (order == 'DESC' && MoshPit.get_size() != 'mobile') {
            this.show_desktop_load_previous();
        }

        this.options.thread.metadata.bookmark = this.ui.thread_wrap.find('.messages-list').children().first().attr('id');
        GP.vent.trigger('MessagePane.Thread:get_thread', this.options.thread.id, false, null, order);
    },
    throttle_user: function() {
        var throttle_msgs = false;
        var my_gender     = GP.sdata.my_user.gender;
        var other_gender  = this.options.user.get('gender').toUpperCase();
        var is_friend     = this.options.user.get('friend');

        // set min/max number of organic messages to check for
        var msg_throttle_min = 5;
        var msg_throttle_max = 10;

        // check for MEN messaging WOMEN that are NOT friends
        if ( _.contains(['MAN', 'TS', 'NON_BINARY'], my_gender) && other_gender == 'WOMAN' && !is_friend) {
            // default to throttle and set to false if we find a message from the other user
            throttle_msgs = true;

            var organic_msgs = [];
            var msgs = this.options.thread.get('messages').models;

            // get organic messages in the thread that are not special msg_ids or system messages/tips etc...
            for (var x = 0; x < msgs.length; x++) {
                let m = msgs[x];
                let sys_msg = !!m.get('msg_system_id');
                let tip_msg = _.contains(m.get('tag'), 'TIP');

                if (m.get('msg_id') > 100 && !tip_msg && !sys_msg) {
                    organic_msgs.push(m);
                }
            }

            // no need to throttle if there are less than msg_throttle_min of organic messages
            if (organic_msgs.length < msg_throttle_min) {
                throttle_msgs = false;
            } else {
                for (var i = 0; i < organic_msgs.length; i++) {
                    if (organic_msgs[i].get('direction') == 'recipient') {
                        throttle_msgs = false;
                        break;
                    }
                }
            }
        }

        return throttle_msgs;
    },
    input_keydown: function(e) {
        var key = e.which || e.keyCode;
        // clear typing status & send message
        if (key && key == 13 && !e.shiftKey) {
            e.preventDefault();
            this.send_idle_status();
            this.add_message();
            return;
        }
        this.send_typing_status();
    },
    add_message: function() {
        // throttle code needed here also in case they click SEND instead of pressing ENTER
        if (this.throttle_user()) {
            this.ui.message_input.val('');
            this.show_notification('danger', js_lang.msg_throttle_explanation);
            return;
        }

        var message = $.trim(this.ui.message_input.val());

        // empty message validation
        if (message.length === 0) {
            this.ui.message_input.val('');
            if (!GP.sdata.is_mobile) {
                this.ui.message_input.trigger('autosize.resize');
            }
            this.show_notification('danger', js_lang.msg_error_empty_msg);
            return;
        }

        // check for priority message
        var tags_array = [];
        var priority = this.ui.priority_input.val();
        if (priority) {
            tags_array.push(priority);
            this.toggle_priority();
        }

        var msgs = this.options.thread.get('messages');
        var first_msg_tag = (msgs.models && msgs.models.length) ? msgs.models[0].get('tag') : [];
        var poke = (_.contains(first_msg_tag, 'POKE')) ? true : false;

        // only the second message in the thread should be tagged as an POKE_RESPONSE
        // so we check for msgs.length of 2, since the thread should only have the orig msg and the response here
        if (poke && msgs.length == 2) {
            tags_array.push('POKE_RESPONSE');
        }

        var msg_obj = {
            thread_id: this.options.thread.id,
            to_duid: this.options.user.id,
            // the marionette view will notice this is an attachment and generate the message
            // content (attachment) based on the message metadata, so no need to do it here
            message: message,
            // message: _.escape(message),
            tags_array: tags_array,
            has_read_status: msgs.has_read_status
        };

        // iterate through msgs.models in reverse order
        let loop_count = 0;
        for (let i = msgs.models.length - 1; i >= 0; i--) {
            let msg_id    = parseInt(msgs.models[i].get('msg_id'), 10);
            let direction = msgs.models[i].get('direction');
            let msg_tag   = msgs.models[i].get('tag') || [];

            // skip special messages like read status, rude user, claimable, etc...
            // since special messages injected into a thread have low msg_id values
            if (msg_id < 100) {
                continue;
            }

            // don't check more than 3 sent messages back
            if (direction == 'sender') {
                if (++loop_count > 3) {
                    this.options.thread.set('claimable', false);
                    msg_obj.mpg_nc = true;
                    break;
                }
            }

            // only add is_priority_guarantee_reply if the user is replying to a
            // priority guarantee message sent from the other user, so they should be the recipient
            if (_.contains((msg_tag), 'PRIORITY_GUARANTEE')) {
                if (direction == 'recipient') {
                    msg_obj.is_priority_guarantee_reply = true;
                    break;
                }
            }
        }

        // add the message and provide an error message callback handler to show the error in the notification area
        GP.vent.trigger('MessagePane.Thread:add_message', msg_obj, this, function(error_msg) {
            if (typeof error_msg != 'undefined' && error_msg) {
                this.show_notification('danger', error_msg);
            }
        });

        this.ui.message_input.val('');
        this.reset_autosize(this.ui.message_input || this.$el.find('textarea.message-input'));
        // if (GP.sdata.my_user.gender == 'MAN') {
        //     this.hide_rude_warning();
        // }
        if (!GP.sdata.is_mobile) {
            this.ui.message_input.trigger('autosize.resize');
        }
    },
    handle_assistant_intro_shown: function() {
        var self = this;
        this.uiState.suggest_intro_shown = true;
        this.ui.suggest_button.off();
        this.ui.suggest_button.click(function(e) { self.suggest_message(); });
        self.suggest_message();
    },
    get_assistant_cookie: function() {
        var assistant_settings = $.cookie(GP.sdata.my_user.duid + ':fl_msg_assistant');
        if (_.isString(assistant_settings)) {
            return JSON.parse(assistant_settings);
        } else if (_.isObject(assistant_settings)) {
            return assistant_settings;
        } else {
            return {};
        }
    },
    suggest_message: function(e) {
        var self = this;
        if (self.uiState.suggest_request_lock) {
            return;
        }

        // user click, the user clicked the wand. they did not specify a personality. if the cookie is different than
        // the dom this is the first click and we should use the cookie value if its set.
        var selected_personality = '';
        if (e && e.type === "click") {
            var assistant_cookie_settings = self.get_assistant_cookie();
            if (assistant_cookie_settings && assistant_cookie_settings.personality) {
                selected_personality = assistant_cookie_settings.personality;
            }
        }

        // fallback to the default in the dom if nothing was found - or if the user just chose a personality
        var dom_selected_personality = $(this.ui.selected_personality).text();
        if (!selected_personality && dom_selected_personality) {
            selected_personality = dom_selected_personality;
        }

        // NOTE: this shouldn't happen, but we'll define a default anyway (its also defined in gp_llm.php)
        if (!selected_personality) {
            selected_personality = 'Flirty';
        }

        $(this.ui.selected_personality).text(selected_personality);

        self.uiState.suggest_request_lock = true;
        self.$el.find(self.ui.suggest_personality).popover('hide');
        self.hide_suggest_personality();
        self.show_suggest_spinner();

        $.post('/members/msg/get_suggestion/', { 'duid' : self.options.user.id, 'personality': selected_personality })
            .success(function(result) {
                // make sure the ui is still there (user can close thread while this request is pending)
                if (result.suggestion && typeof(self.ui.message_input.val) === 'function') {
                    self.ui.message_input.val(result.suggestion);
                    self.reset_autosize(self.ui.message_input || self.$el.find('textarea.message-input'));
                    self.ui.message_input.trigger('autosize.resize');
                    self.show_suggest_personality();
                } else if (result.limits_reached)  {
                    self.show_notification('warning', 'AI Assistant limit reached. Try again tomorrow!');
                } else {
                    self.show_notification('danger', 'Oops, something went wrong.');
                }
            }).fail(function() {
                self.show_notification('danger', 'Oops, something went wrong.');
            }).always(function() {
                self.hide_suggest_spinner();
                self.uiState.suggest_request_lock = false;
            });
    },
    // throttle typing_status() since the typing_idle_timer is set to 1550ms
    // we don't need to (and shouldn't) update typing status on every keypress
    send_typing_status: _.throttle(function() {
        if (this.options.thread.metadata.typing_idle_timer === false) {
            GP.vent.trigger('Cometd:messenger_send_typing_status', this.options.thread.id);
            // show/hide_input_helper() piggybacks on the typing_status functionality
            // because we only want to show it when the user is typing
            this.show_input_helper();
        }
        // reset the timer
        clearTimeout(this.options.thread.metadata.typing_idle_timer);
        // .bind(this) so send_idle_status() will have the correct scope (instead of the global scope)
        this.options.thread.metadata.typing_idle_timer = setTimeout(this.send_idle_status.bind(this), 1550);
    }, 250),
    send_idle_status: function() {
        var self = this;
        clearTimeout(self.options.thread.metadata.typing_idle_timer);
        this.options.thread.metadata.typing_idle_timer = false;
        GP.vent.trigger('Cometd:messenger_send_idle_status', this.options.thread.id);
        this.hide_input_helper();
    },
    should_disable_file_upload: function(e) {
        var disable_attach = false;

        // disable attachments for chatbots (NOTE: all buttons currently hidden for ai-chatbots)
        //if (_ai_chatbot_duids.includes(parseInt(this.options.user.id,10))) {
        //    return true;
        //}

        // check for MEN messaging WOMEN that are NOT friends
        if (GP.sdata.my_user.gender=='MAN' && this.options.user.get('gender').toUpperCase()=='WOMAN' && !this.options.user.get('friend')) {
            var msgs = this.options.thread.get('messages');
            var msg_count = msgs.models.length;
            // if no thread msgs then disable file upload
            if (msg_count === 0) {
                disable_attach = true;
            } else {
                // if we have thread msgs search for an organic reply
                var upload_reply_found = _.find(msgs.models, function(m) {
                    return (m.get('direction')=='recipient' && (m.get('msg_system_id')===null || m.get('system_msg')===false));
                });
                // disable file upload if no organic reply
                disable_attach = (typeof(upload_reply_found) !== 'undefined') ? false : true;
            }
        }
        return disable_attach;
    },
    init_file_upload: function($parentLabelEl) {
        var self = this;
        if (!$parentLabelEl || !$parentLabelEl.length || !$parentLabelEl.is('label')) {
            console.error('unable to init file upload, invalid $parentLabelEl: ', $parentLabelEl);
            return;
        }

        // disable file_upload: no browser support
        if (!window.can_upload_file) {
            //console.error('unable to init file upload, browser has no support');
            this.ui.attach_button.click(function(e) {
                e.preventDefault();
                self.show_notification('warning', js_lang.no_file_upload);
            });
            return;
        }

        var p_input = 0, media_type = '';
        if (!$parentLabelEl.find('input').data('blueimp-fileupload')) {
            var $file_upload_input = $('<input />').attr({
                type:   'file',
                class:  'message-attach-input',
                accept: 'video/*,image/*',
                style: 'display:none',
            });
            $parentLabelEl.find(this.ui.attach_input).remove(); // just in case
            $parentLabelEl.append($file_upload_input);

            this.ui.attach_input = $parentLabelEl.find('input.message-attach-input');

            this.ui.attach_input.fileupload({
                url: '/members/msg/add_photo/?attachment=1&to_duid=' + self.options.user.id,
                dataType: 'json',
                formData: {
                    priority: 0
                },
                start: function (e) {
                    self.show_attach_spinner();
                    self.hide_message_attach_popover();
                },
                add: function (e, upload_data) {
                    var acceptFileTypesImages = /^image\/(gif|jpe?g|png|bmp)$/i;
                    // This is for IE<10 because file mimetypes isn't defined in the upload_data that is returned.
                    var acceptFileExtensionsImages = /\.(gif|jpe?g|png|bmp)$/i;
                    var acceptFileTypesVideos = /^video\/(mp4|m4v|wmv|avi|mov|asf|quicktime|divx|ddat|webm|3gpp|x-flv|ogg|mpeg|mpg|flv)$/i;
                    var acceptFileExtensionsVideos = /\.(mp4|m4v|wmv|avi|mov|asf|ddat|webm|flv|3gp|ogv|mpeg|mpg|mpeg4|mp4v|divx|h264)$/i;

                    if ((typeof (upload_data.originalFiles[0].type) !== 'undefined' && acceptFileTypesImages.test(upload_data.originalFiles[0].type))
                        || typeof (upload_data.originalFiles[0].name) !== 'undefined' && acceptFileExtensionsImages.test(upload_data.originalFiles[0].name
                        )) {
                        media_type = 'image';
                        upload_data.url = '/members/msg/add_photo/?attachment=1&to_duid=' + self.options.user.id;
                    } else if ((typeof (upload_data.originalFiles[0].type) !== 'undefined' && acceptFileTypesVideos.test(upload_data.originalFiles[0].type))
                        || typeof (upload_data.originalFiles[0].name) !== 'undefined' && acceptFileExtensionsVideos.test(upload_data.originalFiles[0].name
                        )) {
                        media_type = 'video';
                        upload_data.url = '/members/msg/add_video/?attachment=1&to_duid=' + self.options.user.id;
                    } else {
                        self.show_notification('danger', js_lang.unacceptable_file_type);
                        return;
                    }

                    if (self.ui.priority_input && typeof self.ui.priority_input.val == 'function') {
                        p_input = self.ui.priority_input.val();
                    } else {
                        var $pi_tmp = self.$el.find('input.priority-input');

                        if ($pi_tmp.length) {
                            p_input = $pi_tmp.val();
                        }
                    }

                    // add priority if priority start is clicked when photo is uploaded
                    if (p_input) {
                        let upload_obj = {
                            media_type: media_type
                        };
                        if (p_input === 'PRIORITY') {
                            upload_obj.priority = 1;
                        }
                        if (p_input === 'PRIORITY_GUARANTEE') {
                            upload_obj.priority_guarantee = 1;
                        }

                        upload_data.formData = upload_obj;
                    } else {
                        upload_data.formData = {
                            media_type: media_type
                        };
                    }

                    // no errors, go ahead with the upload
                    upload_data.submit();
                },
                done: function (e, response) {
                    upload_result = response.result;

                    if (typeof (upload_result.error) !== 'undefined') {
                        self.show_notification('danger', upload_result.error);
                    } else {
                        // TODO: test priority attachments (make sure its all good on the backend)
                        if (p_input === 'PRIORITY' || p_input === 'PRIORITY_GUARANTEE') {
                            self.toggle_priority();
                        }
                        for (var i in upload_result) {
                            if (typeof (upload_result[i].error) !== 'undefined') {
                                let err_msg = upload_result[i].error[0];

                                if (upload_result[i]?.verification_required) {
                                    let $click = $('<a/>')
                                        .attr('href', '/members/user/verify/?self_view=1')
                                        .attr('data-event', 'Modal:open')
                                        .text('Click here to verify');
                                    let $html = $('<div/>').append($('<p/>').text(err_msg), $click);

                                    self.show_notification('danger', null, $html.html());
                                } else {
                                    self.show_notification('danger', err_msg);
                                }

                                break;
                            }

                            if (p_input === 'PRIORITY' || p_input === 'PRIORITY_GUARANTEE') {
                                upload_result[i].tag.push(p_input);
                            }
                            var message_model_attrs = {
                                thread_id: self.options.thread.id,
                                msg_id: upload_result[i].msg_id,
                                to_duid: self.options.user.id,
                                // the marionette view will notice this is an attachment and generate the message
                                // content (attachment) based on the message metadata, so no need to do it here
                                message: '',
                                attachment_url: (upload_result[i].attachment_url || null),
                                tags_array: upload_result[i].tag
                            };
                            GP.vent.trigger('MessagePane.Thread:add_message', message_model_attrs);
                        }
                    }
                    self.hide_attach_spinner();

                    // setup for another upload
                    self.ui.attach_input.val('');
                },
            });
        }
    },
    toggle_msg_approach_pref: function(e) {
        // if the user clicked on a checkbox/label, don't toggle
        $clicked = $(e.target);
        if ($clicked.is('input') || $clicked.is('label')) {
            return;
        }

        if ($('#' + this.id + ' .msg-approach-pref-helper').hasClass('open')) {
            this.hide_msg_approach_pref();
        } else {
            this.show_msg_approach_pref(10000);
        }
    },
    handle_msg_interests_auto_show: function(e) {
        $input = $(e.target);
        e.stopImmediatePropagation();

        // check if $input is checked or not
        if ($input.is(':checked')) {
            // set cookie
            $.cookie('msg_interests_auto_show', 'yes', {
                expires: 365,
                path: '/'
            });

            this.show_msg_approach_pref(1000);
        } else {
            // remove cookie
            $.cookie('msg_interests_auto_show', 'no', {
                expires: 365,
                path: '/'
            });
            this.show_msg_approach_pref(1000);
        }
    },
    toggle_priority: function(e) {
        var self = this;
        if (this.ui.priority_input.val() === 'PRIORITY' || this.ui.priority_input.val() === 'PRIORITY_GUARANTEE') {
            // remove priority
            this.ui.priority_input.val('');
            this.ui.priority_icon.hide();
            this.ui.priority_icon_empty.show();
            self.hide_priority_helper();
        } else {
            if (GP.sdata.my_user.credits > 0) {
                // add priority
                // this.ui.priority_input.val(1);
                // this.ui.priority_icon.show();
                // this.ui.priority_icon_empty.hide();
                // self.show_priority_helper();

                self.trigger_msg_priority_modal();

                clearTimeout(this.options.thread.metadata.priority_helper_timer);
                this.options.thread.metadata.priority_helper_timer = setTimeout(this.hide_priority_helper.bind(self), 2500);
            } else {
                // bind to custom event that the iframe success template will trigger
                $('body').one('fl_credits_purchased', function(e) {
                    _oc = false;
                    // if this is called, we don't need to use the fl_modal_closed event
                    $(document).off('fl_modal_closed');

                    // give the PB some time to update the DB and fire the mod_user_credits cometd message
                    // which should update the user's shared data (sdata)
                    setTimeout(function() {
                        // if we have credits now, just call toggle_priority again
                        if (GP.sdata.my_user.credits > 0) {
                            GP.vent.trigger('Modal:close');
                            self.hide_priority_msg();
                            self.toggle_priority();
                        } else {
                            self.check_credits(self);
                        }
                    }, 2000);
                });

                // bind one time event handler to custom event that will be triggered when the modal closes
                // this is a backup stategy in case the fl_credits_purchased event didn't fire
                $(document).one('fl_modal_closed', $.proxy(self.msg_priority_modal_closed, self));

                // trigger modal to purchase credits if one click is available, or redirect to billing
                if (GP.sdata.my_user.can_oneclick && GP.sdata.my_user.membership !== 'PENDING_FREE') { 
                    GP.vent.trigger('Modal:open', {
                        url: "/members/msg/get_priority_modal/",
                        return_modal_obj: true
                    });
                } else if (GP.sdata.my_user.membership === 'PENDING_FREE') {
                    window.location.href = GP.Util.clean_url('/members/billing/update_cc/');
                } else {
                    var other_duid = this.options.user.id;
                    window.location.href = GP.Util.clean_url('/members/billing/add_credits/?unlock=msg_thread&pduid='+other_duid);
                }
            }
        }
    },
    msg_priority_modal_closed: function(e, $modal) {
        _oc = false;
        var self = this;
        if (typeof $modal != 'undefined' && $modal && $modal.length) {
            try {
                var $iframe = $modal.find('iframe');

                if ($iframe.length) {
                    var iframe_url = $iframe[0].contentWindow.location.href;
                    var re = /purchase_complete/;
                    if (re.test(iframe_url)) {
                        var new_credits = GP.sdata.my_user.credits;
                        if (new_credits > 0) {
                            self.hide_priority_msg();
                            self.toggle_priority();
                        } else {
                            self.check_credits(self);
                        }
                    }
                }
            } catch (exception) {}
        }
    },
    check_credits: function(self) {
        GP.vent.trigger('User:check_credits', self, function(json) {
            var new_credits = parseInt(json.credits, 10);
            if (new_credits > 0) {
                self.hide_priority_msg();
                // add toggle_priority as a callback so it fires after updating credits
                GP.vent.trigger('User:mod_user_credits', json, self.toggle_priority, self);
            }
        });
    },
    scroll_bottom: function(ignore_bookmarks = true) {
        // console.trace('TL.scroll_bottom() ignore_bookmarks: ', ignore_bookmarks);
        var caller = GP.Util.get_caller();
        if (this.ui.nanoscroller.hasClass('nano')) {
            // refresh nanoScroller, then scroll to bottom
            this.ui.nanoscroller.nanoScroller();
            this.ui.nanoscroller.nanoScroller({ scroll: 'bottom' });
        } else {
            this.ui.thread_wrap.scrollTop(9999);
        }
    },
    scroll_down: function() {
        if (this.ui.nanoscroller.hasClass('nano')) {
            // refresh nanoScroller, then scroll to bottom
            this.ui.nanoscroller.nanoScroller();
            this.ui.nanoscroller.nanoScroller({ scrollTop: 300 });

        }
    },
    scroll_to_msg: function(msg_id) {
        let $msg = this.ui.thread_wrap.find('#message_' + msg_id);

        if (this.ui.nanoscroller.hasClass('nano')) {
            // refresh nanoScroller, then scroll to msg
            this.ui.nanoscroller.nanoScroller();
            this.ui.nanoscroller.nanoScroller({ scrollTo: $msg });
        }
    },
    init_nanoscroller: function(open_to_msg_id) {
        var self = this;

        let ns_options = {
            preventPageScrolling: true,
            iOSNativeScrolling: true,
        };

        if (!open_to_msg_id) {
            ns_options.scroll = 'bottom';
        }

        let $ns = this.ui.nanoscroller.addClass('nano').nanoScroller(ns_options);

        $ns.on('scrolltop', function(e) {
            self.load_more(e);
        });

        // scroll down to load next/newer messages
        if (open_to_msg_id && MoshPit.get_size() != 'mobile') {
            self.show_desktop_load_more();
        }
    },
    destroy_nanoscroller: function() {
        this.ui.nanoscroller.removeClass('nano').nanoScroller({ destroy: true });
    },
    add_friend: function() {
        var self = this;

        // setup closure func to add friend request and handle the success/fail UI
        // which can be called right away or passed to the Unlock module if user is BRONZE
        var call_add_friend = function() {
            $.post('/members/network/add_friend/', { 'fuid' : self.options.user.id }, function(post_data) {
                if (post_data.status) {
                    self.show_notification('success', post_data.message);
                    self.options.user.set({ 'friend' : true });
                } else  {
                    if (post_data.redirect) {
                        window.location.replace = post_data.redirect;
                    } else {
                        self.show_notification('danger', post_data.message);
                    }
                }
            });
        };

        // handle purchase friend request if BRONZE user
        if (GP.sdata.my_user.membership == 'BRONZE') {
            GP.vent.trigger('Unlock:show_friend_request_modal', self.options.user.id, call_add_friend);
            return;
        }

        // default to normal adding friend request if BRONZE check logic didn't hit
        call_add_friend();
    },
    add_favorite: function() {
        var self = this;
        $.post('/members/network/add_favorite/', { 'fuid' : self.options.user.id }, function(post_data) {
            if (post_data.status) {
                self.show_notification('success', post_data.message);
                self.options.user.set({ 'favorite' : true });
            } else {
                if (post_data.redirect) {
                    window.location.replace = post_data.redirect;
                } else {
                    self.show_notification('danger', post_data.message);
                }
            }
        });
    },
    grant_private: function() {
        var self = this;
        $.post('/members/content/handle_private_request/', {
            'duid'   : self.options.user.id,
            'status' : 'APPROVED',
            'granted': 1,
        }, function(post_data) {
            if (post_data.status) {
                self.options.user.set('has_access_private', true);
                self.show_notification('success', post_data.message);
            } else {
                self.show_notification('danger', 'Error granting access to private media');
            }
        });
    },
    remove_friend: function() {
        var self = this;
        $.post('/members/network/remove_friend/', { 'fuid' : self.options.user.id }, function(post_data) {
            if (post_data.status) {
                self.show_notification('success', post_data.message);
                self.options.user.set('friend', false);
            } else {
                if (post_data.redirect) {
                    window.location.replace = post_data.redirect;
                } else {
                    self.show_notification('danger', post_data.message);
                }
            }
        });
    },
    remove_favorite: function() {
        var self = this;
        $.post('/members/network/remove_favorite/', { 'fuid' : self.options.user.id }, function(post_data) {
            if (post_data.status) {
                self.show_notification('success', post_data.message);
                self.options.user.set('favorite', false);
            } else {
                self.show_notification('danger', post_data.message);
            }
        });
    },
    revoke_private: function() {
        var self = this;
        $.post('/members/content/handle_private_request/', {
            'duid'   : self.options.user.id,
            'status' : 'DENIED',
            'revoked': 1,
        }, function(post_data) {
            if (post_data.status) {
                self.options.user.set('has_access_private', false);
                self.show_notification('success', post_data.message);
            } else {
                self.show_notification('danger', 'Error revoking access to private media');
            }
        });
    },
    block: function() {
        var self = this;
        $.post('/members/user/block_user/', { 'block_duid' : self.options.user.id }, function(post_data) {
            if (post_data.status) {
                self.close();
                GP.sdata.MessagingThreads.remove(self.options.thread.id);
                GP.sdata.MessagingUsers.remove(self.options.thread.id);
            } else {
                self.show_notification('danger', post_data.message);
            }
        });
    },
    show_message_suggest_popover: function(e) {
        e.preventDefault();

        var self = this;
        if (!this.ui.suggest_personality.data('bs.popover')) {
            this.ui.suggest_personality.popover({
                html: true,
                trigger: 'manual',
                placement: 'top',
                sanitize: false,
                // override the template to increase popover max-width
                template: $('#suggest-popover-template').html(),
                content: $('#suggest-popover-content-template').html(),
            }).on('show.bs.popover', function() {
                // dynamically update popover content before its shown to set selected personality
                var selected_personality = self.$el.find('.selected-personality').text();
                // if we have a cookie personality setting, use it
                var assistant_settings = self.get_assistant_cookie();
                if (assistant_settings && assistant_settings.personality && assistant_settings.personality !== selected_personality) {
                    selected_personality = assistant_settings.personality;
                }

                var selector = '.ai-personality.' + selected_personality.toLowerCase();
                var $popoverContent = $($(this).data('bs.popover').options.content);

                $popoverContent.find('.ai-personality').removeClass('selected');
                $popoverContent.find(selector).addClass('selected');

                var htmlString = '';
                $popoverContent.each(function () {
                    htmlString += ($(this).prop('outerHTML') !== undefined) ? $(this).prop('outerHTML') : '';
                });

                $(this).data('bs.popover').options.content = htmlString;
            });

            // popover button click handler
            $('body').on('click.msg-suggest-popover-personality', '.popover button.ai-personality', function () {
                self.$el.find('.selected-personality').text($(this).text());
                self.suggest_message();
                self.$el.find(self.ui.suggest_personality).popover('hide');
            });
            // popover close button handler
            $('body').on('click.msg-suggest-popover-close', '.close-btn', function () {
                self.$el.find(self.ui.suggest_personality).popover('hide');
            });
        }

        this.$el.find(this.ui.vc_request_private_popover).popover('destroy');
        this.$el.find(this.ui.suggest_personality).popover('show');
    },
    should_disable_premium_file_upload: function(e) {
        var disable_premium_attach = false;

        // check for users messaging each other that are NOT friends
        if (!this.options.user.get('friend')) {
            var msgs = this.options.thread.get('messages');
            var msg_count = msgs.models.length;
            // if no thread msgs then disable file upload
            if (msg_count === 0) {
                disable_premium_attach = true;
            } else {
                // if we have thread msgs search for an organic reply
                var upload_reply_found = _.find(msgs.models, function(m) {
                    return (m.get('direction')=='recipient' && (m.get('msg_system_id')===null || m.get('system_msg')===false));
                });
                // disable file upload if no organic reply
                disable_premium_attach = (typeof(upload_reply_found) !== 'undefined') ? false : true;
            }
        }
        return disable_premium_attach;
    },
    init_premium_file_upload_popover: function() {
        var self = this;
        var thread_id  = self.options.thread.id;

        var other_duid = GP.sdata.MessagingThreads.get(thread_id).get('other_duid');
        var other_duid_max_content_rating = this.options.thread.metadata.other_duid_max_content_rating;
        var other_duid_native_app_reg     = this.options.thread.metadata.other_duid_native_app_reg;

        var $attach_btn = this.$el.find(this.ui.attach_button);

        if (!$attach_btn.data('bs.popover')) {
            $attach_btn.popover({
                html: true,
                trigger: 'manual',
                placement: 'top',
                sanitize: false,
                content: function() {
                    var diamond_svg = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.375 1.5C10.5279 1.5 10.6711 1.56981 10.7652 1.6873L10.8024 1.74051L12.9274 5.2405C13.0278 5.4059 13.023 5.61245 12.9198 5.77175L12.8817 5.82295L7.3817 12.323C7.1953 12.5433 6.86585 12.558 6.66035 12.3671L6.6183 12.323L1.11831 5.82295C0.993316 5.67525 0.965911 5.4705 1.04303 5.29705L1.07261 5.2405L3.19761 1.74051C3.27694 1.60984 3.41091 1.5237 3.5602 1.50421L3.62501 1.5H10.375ZM8.7575 6H5.242L6.9995 10.336L8.7575 6ZM11.422 6H9.8365L8.378 9.5975L11.422 6ZM4.163 6H2.5775L5.621 9.5965L4.163 6ZM4.837 2.5H3.90551L2.3875 5H4.1225L4.837 2.5ZM8.123 2.5H5.8765L5.162 5H8.8375L8.123 2.5ZM10.094 2.5H9.1625L9.877 5H11.612L10.094 2.5Z" fill="white"/></svg>';
                    var premium_evnt = ' <a href="/members/premium/msg_attachment_modal&other_duid='+other_duid+'&thread_id='+thread_id+'" class="no-follow btn btn-primary btn-message-attach-premium" data-event="Modal:open">'+diamond_svg+' <span style="vertical-align:text-bottom;">Premium</span></a> ';

                    // show reg modal for WOMEN that are not approved premium users
                    if (GP.sdata.my_user.premium_status == 'DENIED_INITIAL' || GP.sdata.my_user.premium_status == 'PENDING_INITIAL' || GP.sdata.my_user.premium_status == 'NO_STATUS') {
                        premium_evnt = ' <a href="/members/premium/register_modal&other_duid='+other_duid+'&thread_id='+thread_id+'" class="no-follow btn btn-primary btn-message-attach-premium" data-event="Modal:open" data-backdrop="static" data-keyboard="false">'+diamond_svg+' <span style="vertical-align:text-bottom;">Premium</span></a> ';
                    }

                    if ((other_duid_max_content_rating != null && other_duid_max_content_rating !== 'X') || other_duid_native_app_reg) {
                        premium_evnt = ' <button class="no-follow btn btn-primary btn-message-attach-premium btn-no-premium-notice">'+diamond_svg+' <span style="vertical-align:text-bottom;">Premium</span></button> ';
                    }

                    // disable file_upload: users trying to send attachment with no organic reply
                    if (self.should_disable_premium_file_upload()) {
                        premium_evnt = ' <button class="no-follow btn btn-primary btn-message-attach-premium btn-no-premium-upload">'+diamond_svg+' <span style="vertical-align:text-bottom;">Premium</span></button> ';
                    }

                    return '<div style="width:300px;" class="attach-select-wrap">' +
                        '<p>Send an attachment</p>' +
                        '<label class="attach-file-wrap gp-focus:outline-none gp-mb-0">' +
                            //'<button type="button" class="btn btn-primary" style="height:34.5px;">Upload</button> ' +
                            '<div class="btn btn-primary" style="height:34.5px;">Upload</div> ' +
                        '</label>' +
                        premium_evnt +
                        ' <button type="button" class="no-follow premium-attachment-cancel btn btn-default">cancel</button> ' +
                        '</div>';
                }
            }).on('shown.bs.popover', function(e) {
                var $popover = $(e.target).data('bs.popover').tip();
                // hook up close button
                $popover.find('.premium-attachment-cancel').on('click', function() {
                    $(this).closest('.popover').prev().popover('hide');
                });
                // hook up "does not accept prem attachments" notice
                $popover.find('.btn-no-premium-notice').on('click', function() {
                    alert('This user does not accept premium attachments');
                });
                // hook up "cant upload with an organic reply" error msg
                $popover.find('.btn-no-premium-upload').on('click', function() {
                    self.show_notification('warning', js_lang.no_premium_attachment_explaination);
                });
                // hook up file upload
                $parentLabel = $popover.find('label.attach-file-wrap');
                if ($parentLabel && $parentLabel.length) {
                    self.init_file_upload($parentLabel);
                }
            });

            $attach_btn.click(function(e) {
                $(this).popover('toggle');
            });
        }
    },
    message_attach_modal: function(pc_data) {
        var self = this, p_input = 0;
        var upload_obj = {
            'to_duid'            : self.options.user.id,
            'premium_content_id' : pc_data.premium_content_id,
            'media_type'         : pc_data.media_type
        };
        if (self.ui.priority_input && typeof self.ui.priority_input.val == 'function') {
            p_input = self.ui.priority_input.val();
        } else {
            var $pi_tmp = self.$el.find('input.priority-input');
            if ($pi_tmp.length) {
                p_input = $pi_tmp.val();
            }
        }
        // add priority if priority start is clicked when photo is uploaded
        if (p_input) {
            if (p_input === 'PRIORITY') {
                upload_obj.priority = 1;
            }
            if (p_input === 'PRIORITY_GUARANTEE') {
                upload_obj.priority_guarantee = 1;
            }
        }
        self.show_attach_spinner();
        $.post('/members/msg/add_premium_attachment', upload_obj, function(post_data) {
            if (post_data.status) {
                // TODO: test priority attachments (make sure its all good on the backend)
                if (p_input === 'PRIORITY' || p_input === 'PRIORITY_GUARANTEE') {
                    self.toggle_priority();
                    post_data.tag.push(p_input);
                }
                var message_model_attrs = {
                    thread_id       : self.options.thread.id,
                    msg_id          : post_data.msg_id,
                    to_duid         : self.options.user.id,
                    message         : '',  // the marionette view will notice this is an attachment and generate the message content (attachment) based on the message metadata, so no need to do it here
                    attachment_html : (post_data.attachment_html || null),
                    attachment_info : (post_data.attachment_info || null),
                    attachment_purchased : (post_data.attachment_purchased || null),
                    tags_array      : post_data.tag
                };
                GP.vent.trigger('MessagePane.Thread:add_message', message_model_attrs);
            } else {
                self.show_notification('danger', post_data.message);
            }
            self.hide_attach_spinner();
        });
    },
    hide_message_attach_popover: function() {
        this.$el.find('.message-attach-button').popover('hide');
    },
    vc_request_private_popover: function() {
        var self = this;
        var thread_id = self.options.thread.id;
        var allow_private_vc = GP.sdata.MessagingThreads.get(thread_id).get('messages').allow_private_vc;
        var other_duid = GP.sdata.MessagingThreads.get(thread_id).get('other_duid');
        var other_username = GP.sdata.MessagingUsers.get(other_duid).get('username');
        var ai_chatbot = false;
        if (_ai_chatbot_duids.includes(parseInt(other_duid,10))) {
            allow_private_vc = false;
            ai_chatbot = true;
        }

        var $vc_btn = this.$el.find('.vc-request-private');
        $vc_btn.popover({
            html: true,
            trigger: 'manual',
            // trigger: 'focus',
            // trigger: 'click',
            placement: 'top',
            sanitize: false,
            content: function() {
                var html = '';
                var evnt = ' data-event="ThreadLayout.thread-'+thread_id+':vc_request_private" ';
                var cancel_evnt = ' data-event="ThreadLayout.thread-'+thread_id+':hide_private_popover" ';

                if (allow_private_vc) {
                    html = '<div class="vc-request-popover"><p>Submit a request to start a private 1-to-1 video chat with <span class="username">' + other_username + '</span>?</p><p style="text-align:center"><button '+evnt+' class="btn btn-primary">Send Request</button> <a class="btn btn-default no-follow" href="#" '+cancel_evnt+'>cancel</a></p></div>';
                } else if (ai_chatbot) {
                    html = '<p style="width: 250px;">This user does not accept video chat requests.</p><button type="button" '+cancel_evnt+' class="btn btn-primary btn-dismiss">Ok</button>';
                } else {
                    html = '<p style="width: 250px;">Video chat requests can only be sent to users on your friends list or members that replied to your messages</p><button type="button" '+cancel_evnt+' class="btn btn-primary btn-dismiss">Ok</button>';
                }
                return html;
            }
        });
        this.hide_message_attach_popover();
        $vc_btn.popover('show');
    },
    vc_request_private: function() {
        var self = this;
        var thread_id = self.options.thread.id;

        var post_input = {
            name: 'private 1 to 1 chat',
            isPrivate: true,
            sendRequest: true,
            fromMsgThread: true,
            duids: [self.options.user.id]
        };
        var req_url = '/app/members/rooms/private/'+self.options.user.id+'/sendRequest';
        $.post(req_url, post_input, function(json_response) {

            if (json_response && json_response.vc_url && json_response.online) {
                // redirect to private videochat app
                window.location.href = json_response.vc_url;
                // window.open(json_response.vc_url, 'private-vc-tab');
                return;
            }

            // handle error msgs
            // var cancel_evnt = ' data-event="ThreadMiniProfile.'+thread_id+':hide_private_popover" ';
            var cancel_evnt = ' data-event="ThreadLayout.thread-'+thread_id+':hide_private_popover" ';
            var $popover_content = $('#message-thread-wrap .popover .vc-request-popover');

            if (json_response && !json_response.online) {
                // not online error msg
                $popover_content.html('<p>User is not currently online... Please try again later when user is online</p><p style="text-align:center"><a '+cancel_evnt+' class="btn btn-default no-follow" href="#">Close</a></p>');

                setTimeout(function() {
                    // GP.vent.trigger('ThreadMiniProfile.'+thread_id+':hide_private_popover');
                    GP.vent.trigger('ThreadLayout.thread-'+thread_id+':hide_private_popover');
                }, 2500);
            } else {
                // generic error msg
                $popover_content.html('<p>Request failed... Please try again later</p><p style="text-align:center"><a '+cancel_evnt+' class="btn btn-default no-follow" href="#">Close</a></p>');

                setTimeout(function() {
                    // GP.vent.trigger('ThreadMiniProfile.'+thread_id+':hide_private_popover');
                    GP.vent.trigger('ThreadLayout.thread-'+thread_id+':hide_private_popover');
                }, 2500);
            }
        });
    },
    hide_private_popover: function() {
        // this.ui.vc_request_private
        this.$el.find('.vc-request-private').popover('destroy');
    },
    handle_private_request: function(status) {
        var self = this;
        $.post('/members/content/handle_private_request/', {
            'duid'  : self.options.user.id,
            'status': status
        }, function(post_data) {
            if (post_data.status) {
                self.show_notification('success', post_data.message);
                GP.vent.trigger('FriendPane:decrement_private_count');
            } else {
                self.show_notification('danger', 'Error handling private media request');
            }
        });
    },
    input_blur: function() {
        // Fix for iOS 7 position:fixed bug when showing virtual keyboard.
        if (GP.sdata.is_mobile && navigator.userAgent.match(/(iPad|iPhone);.*CPU.*OS 7_\d/i)) {
            setTimeout(function() {
                $(window).scrollLeft(0);
            }, 350);
        }
    },
    show_read_status_option: function() {
        if (_ai_chatbot_duids.includes(parseInt(this.options.user.id,10))) {
            return;
        }

        var msg_model = {
            msg_id: 4,
            tag: [],
        };
        this.options.thread.get('messages').add(msg_model);
    },
    show_read_status_modal: function() {

        var endpoint   = '/members/msg/read_status_modal/',
            other_duid = this.options.user.id,
            thread_id  = this.options.thread.id;

        var _modal_url = GP.Util.clean_url(endpoint, {
            other_duid: other_duid,
            thread_id:  thread_id
        });

        // trigger modal to purchase credits if one click is available, or redirect to billing
        if ((GP.sdata.my_user.can_oneclick &&  GP.sdata.my_user.membership !== 'PENDING_FREE') || GP.sdata.my_user.credits > 0) {
            vent.trigger('Modal:open', {
                url: _modal_url
            });
        } else if (GP.sdata.my_user.membership === 'PENDING_FREE') {
                    window.location.href = GP.Util.clean_url('/members/billing/update_cc/');
        } else {
            window.location.href = GP.Util.clean_url('/members/billing/add_credits/?msg_read_status=1&pduid='+other_duid);
        }
    },
    show_bronze_claimable: function() {
        var msg_model = {
            msg_id: 6,
            tag: [],
        };

        var messages_collection = this.options.thread.get('messages');
        messages_collection.add(msg_model);

        // setTimeout(function() {
        //     messages_collection.remove(6);
        // }, 10000);
    },
    show_bronze_claimed: function(updated_credits) {
        var msg_model = {
            msg_id: 7,
            tag: [],
        };

        if (updated_credits) {
            msg_model.updated_credits = updated_credits;
        }

        var messages_collection = this.options.thread.get('messages');
        messages_collection.add(msg_model);

        setTimeout(function() {
            messages_collection.remove(7);
        }, 10000);
    },
    reset_autosize: function($ele) {
        autosize.update($ele);
    },
    trigger_msg_hint_modal: function() {
        vent.trigger('Modal:open', {
            url: '/members/modals/message_hint_pref/'
        });
    },
    trigger_msg_priority_modal: function() {
        GP.vent.trigger('MessagePane.Thread:set_sent_msg_priority', {
            thread_id: this.options.thread.id,
            toggle_only: true
        });
    },
    set_priority_input: function(product_type) {
        this.ui.priority_icon.show();
        this.ui.priority_icon_empty.hide();
        this.ui.priority_input.val(product_type);
    }
});
